/**
 * Constants for timer performance marks and measures
 */
export const TIMER_TIMESTAMPS = {
  // Performance marks
  SERVER_MARK: 'SERVER_MARK',
  GAME_MARK: 'GAME_MARK',
  UPDATE_MARK: 'UPDATE_MARK',

  // Performance measures
  CURRENT_MEASURE: 'CURRENT_MEASURE',
  SESSION_MEASURE: 'SESSION_MEASURE',
  GAME_MEASURE: 'GAME_MEASURE',
  TIME_BETWEEN_UPDATES_MEASURE: 'TIME_BETWEEN_UPDATES_MEASURE',
};
